export { MultiClienteList } from "./list";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/viajes/modales/nuevoviaje/multicliente/index.ts